'use client';

import { useEffect, EffectCallback, DependencyList } from 'react';

export const useLowPriorityEffect = (effect: EffectCallback, deps?: DependencyList) => {
  useEffect(() => {
    const handle = setTimeout(() => {
      effect();
    }, 0);

    return () => {
      clearTimeout(handle);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
